import React from 'react';
import PropTypes from 'prop-types';
import logo from '../../assets/img/bugzero/bz-navbar-logo.svg';
import logoDark from '../../assets/img/bugzero/bz-navbar-logo-dark.svg';
import { useTheme } from '../../context/ThemeContext';

// The wordmark is navy on light; on dark it is the tan variant of the same
// file (STRY0039116). Anything that renders the wordmark picks its source here.
export const useLogoSrc = () => {
  const { isDark } = useTheme();
  return isDark ? logoDark : logo;
};

const BugZeroLogo = ({ height = 22 }) => {
  const src = useLogoSrc();
  return <img src={src} alt="BugZero" className="bz-logo" style={{ height, width: 'auto', display: 'block' }} />;
};

BugZeroLogo.propTypes = {
  height: PropTypes.number
};

export default BugZeroLogo;
